
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    schedule: Object,
    gems: Number,
  },
  setup() {
    return {};
  },
});
